import { css } from "styled-components";
import { StyledDialog } from "../../components/Dialog/Dialog";
import { StyledDialogBody } from "../../components/Dialog/DialogBody";
import { PopoverMixin } from "./PopoverMixin";
import { spaceMixin } from "../spaceMixin";
/** @class TooltipMixin */

/** @method */

export var TooltipMixin = function TooltipMixin(props) {
  return css(["", " ", "{max-height:none;width:auto;&:after{content:none;}}", "", "{padding:", " ", ";&:after{content:none;}}"], PopoverMixin(props), StyledDialog, StyledDialogBody, StyledDialogBody, spaceMixin("xs")(props), spaceMixin("sm")(props));
};